import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=118e0ea5&scoped=true"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=118e0ea5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118e0ea5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118e0ea5')) {
      api.createRecord('118e0ea5', component.options)
    } else {
      api.reload('118e0ea5', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=118e0ea5&scoped=true", function () {
      api.rerender('118e0ea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/rights/integral/pointsbalance/balance.vue"
export default component.exports